export const PURCHASE_METHODS = [
  { id: '0', title: 'Repasse', filter: 'repasse' },
  { id: '1', title: 'Cotação', filter: 'cotacao' },
  { id: '2', title: 'Avaliação sob aprovação', filter: 'bidSobAprovacao' }
];

export const VEHICLE_TYPES = [
  {
    id: 'novo',
    title: 'Novo',
    icon: require('@/assets/icons/vehicleCondition/new.svg'),
    tooltip: 'Veículo com menos de 1mil km rodados'
  },
  {
    id: 'usado',
    title: 'Usado'
  },
  {
    id: 'avariado',
    title: 'Avariado',
    icon: require('@/assets/icons/vehicleCondition/damaged.svg'),
    tooltip: 'Veículo contém múltiplas avarias'
  }
];

export const VEHICLE_CONDITIONS = [
  {
    id: 'showroom',
    title: 'Showroom',
    icon: require('@/assets/icons/vehicleCondition/showroom.svg'),
    tooltip: 'Veículo com qualidade de showroom'
  },
  {
    id: 'blindado',
    title: 'Blindado',
    icon: require('@/assets/icons/vehicleCondition/armored.svg'),
    tooltip: 'Veículo blindado'
  }
];

export const REPORT_STATUSES = [
  {
    id: 'approved',
    filter: 'aprovado',
    title: 'Aprovado',
    icon: require('@/assets/icons/report/report-approved.svg'),
    tooltip: 'Veículo com laudo aprovado'
  },
  {
    id: 'restricted',
    filter: 'restricao',
    title: 'Aprovado com restrição',
    icon: require('@/assets/icons/report/report-approved-with-restrictrions.svg'),
    tooltip: 'Veículo contém laudo aprovado com restrição'
  },
  {
    id: 'reproved',
    filter: 'reprovado',
    title: 'Reprovado',
    icon: require('@/assets/icons/report/report-failed.svg'),
    tooltip: 'Veículo contém laudo reprovado'
  },
  {
    id: 'no',
    filter: 'semLaudo',
    title: 'Sem Laudo'
  }
];

export const FUEL_TYPES = [
  { id: 'diesel', title: 'Diesel' },
  { id: 'eletrico', title: 'Elétrico' },
  { id: 'etanol', title: 'Etanol' },
  { id: 'flex', title: 'Flex' },
  { id: 'gasolina', title: 'Gasolina' },
  { id: 'gnv', title: 'GNV' },
  { id: 'hibrido', title: 'Híbrido' }
];

export const TRANSMISSION_TYPES = [
  { id: 'manual', title: 'Manual' },
  { id: 'automatico', title: 'Automático' },
  { id: 'dualogic', title: 'Dualogic' },
  { id: 'imotion', title: 'iMotion' },
  { id: 'semi-automatico', title: 'Semi-Automatico' }
];

export const OPTIONAL_TYPES = [
  { id: 've', title: 'Vidro elétrico' },
  { id: 'dhe', title: 'Direção elétrica' },
  { id: 'abag', title: 'Air bags' },
  { id: 'ac', title: 'Ar condicionado' },
];